am.$(function () {
    // input with currency formatting
    am.$(document).on('change', 'input[data-input-type="currency"]', event => {
        const input = event.target;
        const precision = input.getAttribute('data-precision') ?? 2;
        input.value = number_format(cur2num(input.value), precision);
    });

    // dropdown menus
    am.$(document).on('click', '.am-custom-dropdown-toggle', function () {
        const $dropdown = am.$(this).next('.am-custom-dropdown');

        const $parents = $dropdown.parents();
        // when adding sortable functionality, the parent's z-index is zero and it places the dropdown behind it
        for (const e of $parents) {
            if (e.style.zIndex !== '' && e.style.zIndex !== 'auto' && e.style.zIndex < $dropdown.css('z-index')) {
                e.style.zIndex = 'auto';
                break;
            }
        }

        $dropdown.toggle();
    });

    am.$(document).click(function (e) {
        const target = e.target;
        const $element = am.$(target);

        if (!$element.is('.am-custom-dropdown-toggle') && !$element.parents().is('.am-custom-dropdown-toggle')) {
            am.$('.am-custom-dropdown').hide();
        } else {
            const toggle_id = $element.closest('.am-custom-dropdown-toggle').attr('data-toggle-id');
            if (toggle_id) {
                am.$('.am-custom-dropdown:not(#' + toggle_id + ')').hide();
            }
        }
    });

    initializeTooltips();

    loadMoveAppcuesChecklist();

    get_language_translation('LANG_ERR_VALID_ZIP_CODE');
});

function initializeTooltips() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

function loadMoveAppcuesChecklist(){
    try{
        setTimeout(function() {
            var sidebar = 'right';
            if(am.$('#content_wrapper') && am.$('#content_wrapper').hasClass('farleft')){
                sidebar = 'left';
            }
            try{
                if(am.$('appcues-checklist').hasClass('apcl-left') && sidebar == 'left'){
                    am.$('appcues-checklist').css({
                        'left': '72vw'
                    });
                }
                else if(am.$('appcues-checklist').hasClass('apcl-right') && sidebar == 'right'){
                    am.$('appcues-checklist').css({
                        'right': '72vw'
                    });
                }
                am.$('appcues-checklist').css({
                    'bottom': '0px'
                });
                am.$('appcues-checklists').delay(400).animate({
                    'opacity': '1'
                });
            }
            catch(err){
            }
            
        }, 800)
    }
    catch(err){
    }
}

function show_inline_message(container, message, type){
    var $cont = am.$('#'+container);
    var rd = Math.round(Math.random() * (10000000 - 100) + 100);
    var severity = { danger: 'danger', error: 'danger', warning: 'warning', notice: 'warning', success: 'success', info: 'info' }[type] || 'info';
    var iconPaths = {
        info:    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
        success: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
        warning: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
        danger:  'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
    };
    var role = (severity === 'danger' || severity === 'warning') ? 'alert' : 'status';
    var copyBtn = (message.includes('data-part=') || message.includes('data-emid='))
        ? '<button type="button" class="am-alert__close btn-copy" aria-label="Copy"><i class="fal fa-light fa-clone"></i></button>'
        : '';
    var newel = '<div class="js-am-alert-inline'+rd+' am-alert am-alert--'+severity+'" role="'+role+'">'
        + '<svg class="am-alert__icon" viewBox="0 0 24 24"><path d="'+iconPaths[severity]+'"/></svg>'
        + '<div class="am-alert__body"><div class="am-alert__text">'+message+'</div></div>'
        + copyBtn
        + '<button type="button" class="am-alert__close btn-close" aria-label="Dismiss"><i class="fal fa-times"></i></button>'
        + '</div>';
    $cont.show();
    $cont.append(newel);

    am.$(document).on('click', '.js-am-alert-inline'+rd+' .btn-close', function () {
        const $this = am.$(this).closest('.js-am-alert-inline'+rd);
        $this.fadeOut(500, () => {
            $this.remove();
        });
    });

    am.$(document).on('click', '.js-am-alert-inline'+rd+' .btn-copy', function () {
        const $this = am.$(this).closest('.js-am-alert-inline'+rd);
        const text = $this.text();
        navigator.clipboard.writeText(text);
        show_snackbar({
            message: get_language_translation('LANG_MSG_COPIED_TO_CLIPBOARD')
        });
    });
}

function checkSnackbarShowClose(inputString) {
    return inputString.includes('href') || inputString.includes('<button');
}

function extractDataValue(val, attr) {
    const regex = new RegExp(attr + '="([^"]+)"');
    const match = val.match(regex);

    return match ? match[1] : null;
}

/**
 * Sanitize server flash-message markup before it is rendered as a toast.
 *
 * notification_to_snackbar only renders messages built by our own PHP flash
 * framework ($success/$error/$debug/$adminmsg ->output()), which is HTML by
 * design (links, line breaks, lists). But some of those messages interpolate
 * unescaped user data server-side (contact/item names on import, etc.), so we
 * allowlist a safe subset of tags/attributes and drop scripts, inline event
 * handlers and javascript:/data: URLs to keep that from being an XSS sink.
 * Parsing happens in an inert DOMParser document, so no resources load and no
 * onerror handlers fire during sanitization.
 */
function sanitize_notification_html(html) {
    var ALLOWED_TAGS = {
        A: true, BR: true, B: true, STRONG: true, I: true, EM: true, U: true,
        SMALL: true, P: true, SPAN: true, DIV: true, UL: true, OL: true, LI: true
    };
    // Tags that are dropped along with their contents (rather than unwrapped),
    // so raw script/style source never leaks through as visible text.
    var DROP_CONTENT = {
        SCRIPT: true, STYLE: true, TEMPLATE: true, IFRAME: true,
        OBJECT: true, EMBED: true, NOSCRIPT: true
    };
    var GLOBAL_ATTRS = { 'class': true };
    var TAG_ATTRS = { A: { href: true, target: true, rel: true, title: true } };

    var doc = new DOMParser().parseFromString(
        '<div id="am-sanitize-root">' + String(html == null ? '' : html) + '</div>', 'text/html');
    var root = doc.getElementById('am-sanitize-root');
    if (!root) return '';

    var walk = function (node) {
        // Static copy of the children: the tree is mutated while iterating.
        var children = Array.prototype.slice.call(node.childNodes);
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (child.nodeType === 1) { // element
                var tag = child.tagName;
                if (DROP_CONTENT[tag]) {
                    // Remove the element and everything inside it.
                    node.removeChild(child);
                    continue;
                }
                if (!ALLOWED_TAGS[tag]) {
                    // Drop the tag but keep its (sanitized) contents.
                    walk(child);
                    while (child.firstChild) node.insertBefore(child.firstChild, child);
                    node.removeChild(child);
                    continue;
                }
                var attrs = Array.prototype.slice.call(child.attributes);
                for (var a = 0; a < attrs.length; a++) {
                    var name = attrs[a].name.toLowerCase();
                    var allowed = GLOBAL_ATTRS[name] || (TAG_ATTRS[tag] && TAG_ATTRS[tag][name]);
                    if (!allowed) { child.removeAttribute(attrs[a].name); continue; }
                    if (name === 'href') {
                        // Normalize away whitespace/control chars before testing the scheme.
                        var href = attrs[a].value.replace(/[\x00-\x20\x7f]+/g, "").toLowerCase();
                        if (/^(?:javascript|data|vbscript):/.test(href)) child.removeAttribute('href');
                    }
                }
                walk(child);
            } else if (child.nodeType !== 3) {
                // Strip comments/CDATA/etc.; keep text nodes (3).
                node.removeChild(child);
            }
        }
    };
    walk(root);
    return root.innerHTML;
}

function notification_to_snackbar(message, type){
    var timer = 4000;
    let overrideTimer = false;
    var autoClose = true;
    var showClose = false;
    var msgArray = message.split("<br>\n");

    if((msgArray.length - 1) > 5 && !msgArray[0].includes('data-emid')){
        overrideTimer = msgArray.length * 4000;
        msgArray = [ message ];
    }

    var inlineerrorcnt = 0;
    var cleanArray = msgArray.filter(function (el) {
        return el != null && el != "";
    });

    if(type == 'error')
        type = 'danger';
    else if(type == 'notice')
        type = 'warning';

    let required_type = false;
        required_type = type == 'danger' ? true : false;

    am.$.each( cleanArray,
        /**
         * @param {number} i
         * @param {string} val
         */
        function( i, val ) {
            let push_error_to_input = false;

            if (val.includes('data-emid') && am.$(val).data('emid')) {
                show_inline_message(am.$(val).data('emid'), val, type);
                if(type == 'danger')
                    inlineerrorcnt++;
            } else {
                let required_type = false;
                required_type = type == 'danger' ? true : false;
                
                if(val.includes('data-notification')){ // updated process
                        autoClose = extractDataValue(val, 'data-ac') == 1 ? true : false;
                        showClose = extractDataValue(val, 'data-sc') == 1 ? true : false;
                        timer = Number(extractDataValue(val, 'data-timer'));
                }else{ // backwards compatibility
                    if( checkSnackbarShowClose(val) || val.length > 70 && required_type ){
                        autoClose = false;
                        showClose = true;
                        timer = 0;
                    }
                    else{
                        autoClose = true;
                        showClose = false;
                        timer = 4000;
                    }
                }
            }

            if(inlineerrorcnt == 0){
                show_snackbar({
                    // val is server-built flash markup; sanitize it and render as HTML
                    // (raw val is still used above for data-*/href behavior detection).
                    message: sanitize_notification_html(val),
                    html: true,
                    type: type,
                    show_close: overrideTimer ? true : showClose,
                    autoClose: autoClose,
                    timer: overrideTimer ? overrideTimer : timer
                });
            }
        }
    );

    if(inlineerrorcnt > 0){
        show_snackbar({
            message: get_language_translation('LANG_THERE_ARE') + ' ' + inlineerrorcnt + ' ' + get_language_translation('LANG_ERRORS_ON_THIS_PAGE') + '.',
            type: 'danger',
            show_close: showClose,
            autoClose: autoClose,
            timer: 4000
        });
    }
}

function validateTrigger(){
    var act = am.$('#v_form #action').val();
    var optname = am.$('#event').val();
	var typ = optname.split('_')[0];
    switch(act) {
        case 'send_email':
            var tname = '#v_form #action_email';
            var ta = editorData= CKEDITOR.instances['action_email'].getData();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_EMAIL');
            break;
        case 'send_sms':
            var tname = '#v_form #action_sms';
            var ta = am.$(tname).val();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_SMS');
            break;
        case 'add_announcement':
            var tname = '#v_form #action_announcement';
            var ta = am.$(tname).val();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_ANNOUNCEMENTS');
            break;
        case 'add_task':
            var tname = '#v_form #action_task';
            var ta = am.$(tname).val();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_TASK');
            break;
        case 'add_tags':
            var tname = '#v_form #tags_add_' + typ;
            var ta = am.$(tname).val();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_ADD_TAG');
            break;
        case 'remove_tags':
            var tname = '#v_form #tags_remove_' + typ;
            var ta = am.$(tname).val();
            var alertmsg = get_language_translation('LANG_TRIGGER_ALERT_REMOVE_TAG');
            break;
        default:
            // code block
    }
   
    //if var is there check for the action body
    var submitform = false;
    if(typeof ta !== 'undefined'){
        if(ta.length > 0 && ta != '[]'){
            submitform = true;
        }
        else{
            am.$(tname).addClass('am-form-field-error').focus();
            show_snackbar({
                message: alertmsg,
                type: 'danger'
            });
        }
    }
    else{
        submitform = true;
    }
    if(optname === "remake_status_change"){
        var ac = document.querySelectorAll('#addcons');
        [].forEach.call(ac, function(div) {
            if(div.value === "b2b_items"){
                am.$(tname).addClass('am-form-field-error').focus();
                show_snackbar({
                    message: get_language_translation('LANG_DONT_USE_B2B_ITEMS_ON_REMAKE_STATUS_CHANGE'),
                    type: 'danger'
                });
                submitform = false;
            }
        
        });
    }
    if(submitform == true){
        return saveChanges($('v_form'));
    }
}
